import { createTheme } from "@mui/material/styles";
import { cpGreen, cpOrange } from "./variables";

const muiTheme = createTheme({
  palette: {
    primary: {
      main: cpGreen,
    },
    secondary: {
      main: cpOrange,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
  typography: {
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          zIndex: "99",
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          fontSize: "1.1rem",
        },
      },
    },
  },
});

export default muiTheme;
